import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SpinnerBlock from 'components/others/SpinnerBlock';
import TableHeadTdOrder from 'components/others/TableHeadTdOrder';
import { useAuth } from 'context/AuthContext';
import { hasUserAccess } from 'utils/helpers/access/hasUserAccess';
import type { VendorType } from '@econtractor/types';
import { useVendors } from '../context/VendorsProvider';
import VendorsTableBody from './VendorsTableBody';

interface VendorsTableProps {
    vendorsList: VendorType[];
    fetchVendors: (force?: boolean) => Promise<void>;
    setEditVendorId: (vendorId: number) => void;
    setSubjectsVendorId: (vendorId: number) => void;
    setPersonsVendorId: (vendorId: number) => void;
    onOpenPrimaryContacts: (vendor: VendorType) => void;
}

const VendorsTable = ({
    vendorsList,
    fetchVendors,
    setEditVendorId,
    setSubjectsVendorId,
    setPersonsVendorId,
    onOpenPrimaryContacts,
}: VendorsTableProps) => {
    const { t } = useTranslation(['Vendors']);
    const { auth } = useAuth();
    const canEdit = hasUserAccess(auth?.user, 'prodEdit');
    const { showSpinner, vendorsOrder, setVendorsOrder, vendorsDesc, setVendorsDesc } = useVendors();

    const handleOrderClick = (value: string, desc: boolean) => {
        setVendorsOrder(value);
        setVendorsDesc(desc);
    };

    return (
        <div className="position-relative">
            <SpinnerBlock onlyBlur={true} show={showSpinner} />

            <div className="crm-table-wrap">
                <Table className="VendorsTable table-hover">
                    <thead>
                        <tr className="bg-light">
                            <td className="head-name">
                                <TableHeadTdOrder
                                    title={t('fields.name')}
                                    onClick={handleOrderClick}
                                    value={vendorsOrder}
                                    desc={vendorsDesc}
                                    fieldName="v_dir_vendor.vendor_name"
                                />
                            </td>
                            <td className="head-contact-person">{t('fields.contactPerson')}</td>
                            <td className="head-website">
                                <TableHeadTdOrder
                                    title={t('fields.website')}
                                    onClick={handleOrderClick}
                                    value={vendorsOrder}
                                    desc={vendorsDesc}
                                    fieldName="v_dir_vendor.vendor_website"
                                />
                            </td>
                            <td className="head-products">
                                <TableHeadTdOrder
                                    title={t('fields.products')}
                                    onClick={handleOrderClick}
                                    value={vendorsOrder}
                                    desc={vendorsDesc}
                                    fieldName="products_count"
                                />
                            </td>
                            {canEdit && <td className="head-action">{t('fields.action')}</td>}
                        </tr>
                    </thead>

                    <VendorsTableBody
                        vendorsList={vendorsList}
                        fetchVendors={fetchVendors}
                        setEditVendorId={setEditVendorId}
                        setSubjectsVendorId={setSubjectsVendorId}
                        setPersonsVendorId={setPersonsVendorId}
                        onOpenPrimaryContacts={onOpenPrimaryContacts}
                    />
                </Table>
            </div>
        </div>
    );
};

export default VendorsTable;
